// 强制修复布局问题
document.addEventListener('DOMContentLoaded', function() {
  // 1. 修复 main-content 的 padding
  var mainContent = document.querySelector('.main-content');
  if (mainContent) {
    mainContent.style.paddingTop = '80px';
  }
  
  // 2. 修复导航栏宽度
  var navBottomBar = document.querySelector('.nav-bottom-bar');
  if (navBottomBar) {
    navBottomBar.style.maxWidth = 'none';
    navBottomBar.style.width = '100%';
  }
  
  // 3. 修复 body 的 margin/padding
  document.body.style.margin = '0';
  document.body.style.padding = '0';
  
  // 4. 确保所有 section 全宽
  var sections = document.querySelectorAll('section');
  sections.forEach(function(section) {
    section.style.width = '100%';
    section.style.boxSizing = 'border-box';
  });
  
  console.log('Layout fix applied');
});

